import { z } from 'zod';
// ── Document slugs ────────────────────────────────────────────────────────────
export const ContentSlugSchema = z.enum(['privacy_policy', 'terms_of_use', 'about_app']);
// ── Mobile GET /content/:slug?locale= ────────────────────────────────────────
export const ContentDocumentResponse = z.object({
    slug: ContentSlugSchema,
    title: z.string(),
    bodyHtml: z.string(),
    /** Optional link rendered under the body ("view the full document online"). */
    externalUrl: z.string().nullable(),
    version: z.number().int(),
    updatedAt: z.string(),
});
// ── Admin GET /admin/content/documents/:slug ─────────────────────────────────
export const ContentDocumentTranslationSchema = z.object({
    locale: z.string(),
    title: z.string(),
    bodyHtml: z.string(),
});
export const AdminContentDocumentResponse = z.object({
    slug: ContentSlugSchema,
    version: z.number().int(),
    published: z.boolean(),
    externalUrl: z.string().nullable(),
    updatedAt: z.string(),
    translations: z.array(ContentDocumentTranslationSchema),
});
// ── Admin PUT /admin/content/documents/:slug ─────────────────────────────────
export const UpdateContentDocumentBody = z.object({
    published: z.boolean().optional(),
    /** Omit to leave unchanged; null clears it. One link per document, all locales. */
    externalUrl: z.string().url().max(500).nullable().optional(),
    translations: z.array(z.object({
        locale: z.string().min(2).max(5),
        title: z.string().min(1).max(200),
        bodyHtml: z.string().min(1),
    })).min(1),
});
// ── Demo video ────────────────────────────────────────────────────────────────
export const DemoVideoTranslationSchema = z.object({
    locale: z.string(),
    title: z.string(),
    description: z.string().nullable(),
});
export const DemoVideoSchema = z.object({
    id: z.string().uuid(),
    videoUrl: z.string(),
    thumbnailUrl: z.string().nullable(),
    sortOrder: z.number().int(),
    active: z.boolean(),
    title: z.string(),
    description: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
// ── Mobile GET /demo-videos?locale= ──────────────────────────────────────────
export const DemoVideoListResponse = z.object({
    videos: z.array(DemoVideoSchema),
});
// ── Admin GET /admin/demo-videos ─────────────────────────────────────────────
export const AdminDemoVideoSchema = DemoVideoSchema.extend({
    translations: z.array(DemoVideoTranslationSchema),
});
export const AdminDemoVideoListResponse = z.object({
    videos: z.array(AdminDemoVideoSchema),
});
// ── Admin POST /admin/demo-videos ────────────────────────────────────────────
export const CreateDemoVideoBody = z.object({
    videoUrl: z.string().url(),
    sortOrder: z.number().int().min(0).default(0),
    active: z.boolean().default(true),
    translations: z.array(z.object({
        locale: z.string().min(2).max(5),
        title: z.string().min(1).max(200),
        description: z.string().max(500).optional().nullable(),
    })).min(1),
});
// ── Admin PATCH /admin/demo-videos/:id ───────────────────────────────────────
export const UpdateDemoVideoBody = z.object({
    videoUrl: z.string().url().optional(),
    sortOrder: z.number().int().min(0).optional(),
    active: z.boolean().optional(),
    translations: z.array(z.object({
        locale: z.string().min(2).max(5),
        title: z.string().min(1).max(200),
        description: z.string().max(500).optional().nullable(),
    })).optional(),
});
// ── Admin PUT /admin/demo-videos/:id/thumbnail ───────────────────────────────
export const UploadThumbnailBody = z.object({
    base64: z.string().min(1),
    mimeType: z.string().min(1),
});
//# sourceMappingURL=content.js.map